'use server';

import { apiRequest } from '@/utils/api-request';

export interface Teacher {
  id: number;
  uuid: string;
  name: string;
  email: string;
  phone?: string;
  photo_url?: string | null;
  is_active: boolean;
  created_at: string;
}

export async function getTeachers() {
  return apiRequest<Teacher[]>('/api/parent-app/admin/teachers', { method: 'GET' });
}

export async function createTeacher(payload: { name: string; email: string; phone?: string }) {
  return apiRequest<Teacher>('/api/parent-app/admin/teachers', {
    method: 'POST',
    body: payload
  });
}

export async function updateTeacher(id: number, payload: { name?: string; phone?: string; is_active?: boolean }) {
  return apiRequest<Teacher>(`/api/parent-app/admin/teachers/${id}`, {
    method: 'PUT',
    body: payload
  });
}

export async function deleteTeacher(id: number) {
  return apiRequest(`/api/parent-app/admin/teachers/${id}`, { method: 'DELETE' });
}

export async function uploadTeacherPhoto(id: number, file: File) {
  const form = new FormData();
  form.append('photo', file);
  const { default: Cookies } = await import('js-cookie');
  const token = Cookies.get('crm_auth_token');
  const apiBase = (import.meta as any).env?.VITE_API_URL || 'http://localhost:8000/api';
  const res = await fetch(`${apiBase}/parent-app/admin/teachers/${id}/photo`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: 'include',
    body: form,
  });
  return res.json();
}
